/**
 * Safe blob fetch utility - handles backend errors gracefully.
 * When responseType is 'blob', Axios crashes trying to read error.responseText.
 * This wrapper uses validateStatus to prevent that crash.
 */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export async function fetchPdfBlob(endpoint, chantierId) {
  const sep = endpoint.includes('?') ? '&' : '?';
  const url = `${API}/${endpoint}${chantierId ? `${sep}chantier_id=${chantierId}` : ''}`;
  return safeBlobGet(url);
}

export async function safeBlobGet(url) {
  const response = await axios.get(url, {
    withCredentials: true,
    responseType: 'blob',
    validateStatus: () => true,
    timeout: 120000,
  });

  if (response.status >= 400) {
    let errorMsg = 'Erreur serveur';
    try {
      const text = await response.data.text();
      const parsed = JSON.parse(text);
      errorMsg = parsed.detail || errorMsg;
    } catch (_e) { void _e; }
    throw new Error(errorMsg);
  }

  return response;
}

export async function safeBlobPost(url, data) {
  const response = await axios.post(url, data, {
    withCredentials: true,
    responseType: 'blob',
    validateStatus: () => true,
    timeout: 120000,
  });

  if (response.status >= 400) {
    let errorMsg = 'Erreur serveur';
    try {
      const text = await response.data.text();
      const parsed = JSON.parse(text);
      errorMsg = parsed.detail || errorMsg;
    } catch (_e) { void _e; }
    throw new Error(errorMsg);
  }

  return response;
}
